import React, { createContext, useEffect, useState } from "react";
import loginAPI from "../services/loginAPI";
import reservationAPI from "../services/reservationAPI";
import usersAPI from "../services/usersAPI";

export const GlobalContext = createContext();

export const GlobalContextProvider = (props) => {
  const [workersReport, setWorkersReport] = useState([]);
  const [currentPage, setCurrentPage] = useState([]);
  const [searchText, setSearchText] = useState([]);
  const [user, setUser] = useState({});
  const [users, setUsers] = useState([]);

  const [reservationsBystatus, setReservationsByStatus] = useState([]);
  const [reservations, setReservations] = useState([]);
  const getReservationByStatus = async () => {
    await reservationAPI.getreservationsByStatus().then((res) => {
      setReservationsByStatus(res.data);
      console.log("CONTEXT", res.data);
    });
  };
  useEffect(async () => {
    if (loginAPI.isAuthenticated) {
      setUser(loginAPI.currentUser());
    }
    if (users.length <= 0) {
      await usersAPI.getUsers().then((res) => {
        setUsers(res.data.users);
      });
    }

    getReservationByStatus();
  }, [users]);
  return (
    <GlobalContext.Provider
      value={{
        workersReport,
        setWorkersReport,
        currentPage,
        setCurrentPage,
        searchText,
        setSearchText,
        setUser,
        user,
        users,
        reservations,
        reservationsBystatus,
        setReservations,
        setReservationsByStatus,
        getReservationByStatus,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
